/**
 * @desc 列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.ProductBrandModel>>;
export function request(
  body: defs.basics.ProductBrandRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productBrand/list`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
